// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","AppHeader":"App_AppHeader__2Hhu3"};